import { prop, inject, ComponentEventBus } from "fw";
import { Form } from "fw-model";

@inject
export class ToggleFormField {
    @prop(null) public form!: Form;
    @prop(null) public field;
    @prop(null) public label!: string;
    @prop(false) public disabled;

    private name = "";

    constructor(private ceb: ComponentEventBus) {}

    public attached() {
        this.formChanged();
    }

    private formChanged() {
        this.name = this.form && this.form.getFieldName ? this.form.getFieldName(this.field) : this.field;
    }
}
